module.exports = __webpack_public_path__ + "static/media/police_officer.3b6748ca.webp";